import React, { useEffect } from 'react'
import { View, Text, TextInput } from 'react-native'
import { formStyles } from './styles'
import { useValuesDeclareFailure } from '../../hooks/useValuesDeclareFailure'
import { handleFormatValue } from '../../helpers'
import { inputStyle } from '../../../../theme/inputs'
import { FailureValues } from '../../../../types'
import { useTranslation } from 'react-i18next'

interface Values {
  diver: string
  ship: string
}

interface Props {
  initialValues?: FailureValues
  getValues: (values: FailureValues) => void
}
export const CategoryFourFailureForm = ({ getValues, initialValues }: Props) => {
  const { t } = useTranslation()
  const { handleAddSymbol, handleChange, values } = useValuesDeclareFailure<Values>({
    diver: initialValues?.diver ? `${initialValues?.diver}` : '',
    ship: initialValues?.ship ? `${initialValues?.ship}` : '',
  })

  useEffect(() => {
    getValues({
      diver: handleFormatValue(values.diver),
      ship: handleFormatValue(values.ship),
      noRelief: null,
      hydraulic: null,
      dotation: null,
      work: null,
    })
  }, [values])

  return (
    <View style={formStyles.container}>
      <View style={{ marginVertical: 10 }}>
        <Text style={formStyles.label}>{t('BUZO')}</Text>
        <TextInput
          keyboardType='numeric'
          inputMode='numeric'
          onChangeText={(value) => handleChange(value, 'diver')}
          onEndEditing={(value) => handleAddSymbol(value.nativeEvent.text, 'diver')}
          value={values.diver}
          style={[inputStyle.basicInput]}
          placeholder={t('Ingresar % de Falla')}
        />
      </View>

      <View style={{ marginVertical: 10 }}>
        <Text style={formStyles.label}>{t('BARCO')}</Text>
        <TextInput
          keyboardType='numeric'
          inputMode='numeric'
          onChangeText={(value) => handleChange(value, 'ship')}
          onEndEditing={(value) => handleAddSymbol(value.nativeEvent.text, 'ship')}
          value={values.ship}
          style={[inputStyle.basicInput]}
          placeholder={t('Ingresar % de Falla')}
        />
      </View>
    </View>
  )
}
